import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-records',
  templateUrl: './my-records.component.html'
})
export class MyRecordsComponent implements OnInit {

  	
  constructor() { }

  ngOnInit() {
  	
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/time/components/my-records/my-records.component.ts